<template>
    <div class="animated fadeIn">
        <el-card header="品类管理">
            <div slot="header" style="border-bottom:0;">
                <span style="font-size:20px;">品类管理</span>
            </div>
            <el-row>
                <el-col>
                    <el-button type="primary" style="margin-bottom: 2%;margin-top: 2%" class="m-1" @click="newCate"><i class="fa fa-plus"></i>&nbsp;新增</el-button>
                    <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false">
                <span class="m-2" slot-scope="{ node, data }">
                  <img class="img-avatar" style="width: 1rem" @click="() => getCateConfig(data)"/>
                  <span>{{ data.categoryName }}</span>
                  <span>
                    <el-button type="text" size="medium" @click="() => edit(data, '编辑品类')">编辑 <i
                            class="el-icon-edit-outline"></i></el-button>
                    <el-button v-show="node.level === 1" type="text" size="medium" @click="() => append(node, data, '新增品类')"> 新增<i
                            class="el-icon-plus"></i></el-button>
                    <el-button type="text" size="medium" @click="() => remove(node, data, '删除品类')"> 删除<i
                            class="el-icon-delete"></i></el-button>
                    <el-button type="text" size="medium" @click="() => toPro(data)">查看商品<i
                            class="el-icon-search"></i></el-button>
                    <!--<el-button type="text" size="medium" @click="() => getCateConfig(data)">设置<i-->
                            <!--class="el-icon-setting"></i></el-button>-->
                  </span>
                </span>
                        </el-tree>
                </el-col>
            </el-row>
        </el-card>
        <el-dialog title="编辑分类详情" :visible.sync="cateEditModel" width="60%" center>
            <div style="text-align:center;margin:10px;">
                <el-card :header="'分类信息[' + CateName + ']'" style="margin:1rem;text-align:left;">
                    <el-row>
                        <el-col :span="8">
                            <img :src="imageUrl" style="width:80%;"/>
                            <b-form-file :plain="true" :multiple="true" v-model="image" center></b-form-file>
                        </el-col>
                        <el-col :span="16">
                            <el-card :header="'分类优先级'">
                                <el-slider v-model="selectCate.Node.Data.Index" show-input show-stops :max="10"></el-slider>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-card>
                <el-row style="margin:1rem;text-align:left;">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>其他配置</span>
                            <el-button style="float: right;" type="primary" class="m-0" @click="addDomain">新增配置</el-button>
                        </div>
                        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm">
                            <el-form-item
                                    v-for="(domain, index) in dynamicValidateForm.domains"
                                    :prop="'domains.' + index + '.value'"
                                    :key="index"
                                    :rules="{
                    required: true, message: '配置不能为空', trigger: 'blur'
                  }">
                                <el-row>
                                    <el-col :span="4">
                                        <el-input placeholder="请输入新的配置" v-model="domain.key"></el-input>
                                    </el-col>
                                    <el-col :span="14">
                                        <el-input placeholder="请输入新的配置内容" v-model="domain.value"></el-input>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button type="danger" @click.prevent="removeDomain(domain)">删除</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </el-row>
                <span slot="footer" style="margin-top:10px;" class="dialog-footer">
          <el-button @click="cateEditModel = false">取 消</el-button>
          <el-button type="primary" @click="updateCate(selectCate);updateCateConfig(selectCate.Node);cateEditModel = false">确 定</el-button>
        </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'// 引入axios
    export default {
        name: 'cate',
        data: () => {
            return {
                data: [],
                radio1: 0,
                childrenCateGoryList: [],
                cateEditModel: false,
                inputflag: false,
                selectCate: {
                    Node: {
                        Data: {
                            Index: 0
                        }
                    }
                },
                Parent : {
                    'ParentID': '',
                    'ID':'',
                    'Index': 0,
                    'Name': 'Category-1',
                    'Notes': 'Here is Notes',
                    'Thumbnail': {
                        'ID': '',
                        'Type': '',
                        'Md5': '',
                        'Size': 0,
                        'Width': 0,
                        'Height': 0,
                        'Url': ''
                    },
                    'Config': {}
                },
                image: '',
                flag: false,
                imageUrl: 'static/img/default.jpeg',
                config: {},
                dynamicValidateForm: {
                    domains: [{
                        key: '',
                        value: ''
                    }]
                }
            }
        },
        created: function () {
            this.getCate()
        },
        computed: {
            /**
             * @return {string}
             */
            CateName: function () {
                if (this.selectCate.Node) {
                    return this.selectCate.Node.Data.Name
                } else {
                    return ''
                }
            }
        },
        watch: {
            image: function (newQuestion, oldQuestion) {
                var reader = new FileReader()
                reader.readAsDataURL(this.image[0])
                var that = this
                reader.onload = function () {
                    that.imageUrl = this.result
                }
            }
        },
        methods: {
            getCate: function () {
                var params = {tenantId:this.getcookie('storeId')};
                this.$http.get(this.productURL+"/vueFeign/category",{params:params}
                ).then(res => {
                    if (res.status === 200) {
                        if (res.data.Code === '200') {
                        var li = res.data.Data.Category
                        for (var i = 0; i < li.length; i++) {
                            var item = li[i]
                            item.children = item.Children
                        }
                        this.data = res.data.Data.Category
                        console.log('this data')
                        this.childrenCateGoryList = res.data.Data.Category[0].Children
                        console.log(this.data)
                    } else {
                        this.$message.error('数据获取失败，异常：' + res.data.Meta)
                    }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.items = []
                    }
                },function(response){
                    this.items = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            radioKey(val) {
                let categorys = this.data
                this.childrenCateGoryList = categorys[val].Children
            },
            append (node, data, type) {
                this.$prompt('请输入类名', type, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    var params = {tenantId:this.getcookie('storeId'),categoryName:value};
                    this.$http.post(this.productURL+"/vueFeign/uniquenessName",params
                    ).then(res => {
                        if (res.status === 200) {
                            if (res.data.Code === '200') {
                                this.Parent.ParentID = data.categoryId
                                this.Parent.Config = {}
                                this.Parent.Name = value
                                var that = this;
                                axios({
                                    method: 'post',
                                    url: this.productURL+"/vueFeign/category/add",
                                    data: {
                                        Category:this.Parent,
                                        tenantId:that.getcookie('storeId'),
                                    }
                                }).then(function(res) {
                                    if (res.status === 200) {
                                        if (res.data.Code === '200') {
                                            that.fusionCateAdd(res.data.cgId);
                                            that.getCate();
                                        } else {
                                            that.$message.error('数据获取失败，异常：' + res.data.Meta)
                                        }
                                    }
                                });
                            } else if(res.data.Code === '201'){
                                this.$message.error('名称已存在')
                            }
                        }
                    },function(response){
                        this.items = []
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                }).catch(() => {
                    this.$message({type: 'info', message: '取消'})
                })
            },
            remove (node, data, type) {
                this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    var params = {categoryId:data.categoryId,tenantId:this.getcookie('storeId')};
                    this.$http.post(this.productURL+"/vueFeign/category/delete",params
                    ).then(res => {
                        if (res.status === 200) {
                            if (res.data.Code === '200') {
                                this.fusionCateUpdate('delete',data.categoryId);

                            }else if(res.data.Code === '202'){
                                this.$message.error('有商品，暂不可删除')
                            }else if(res.data.Code === '203'){
                                this.$message.error('有子类，暂不可删除')
                            } else {
                                this.$message.error('数据获取失败，异常：' + res.data.Meta)
                            }
                        }
                    },function(response){
                        this.items = []
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })

                }).catch(() => {
                    this.$message({type: 'info', message: '已取消删除'})
                })
            },
            edit (data, type) {
                this.Parent.Name = data.categoryName;
                this.$prompt(this.Parent.Name + '(请输入新类目名称)', type, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:(val) => {
                        if (val === null || val.trim() !== '') {
                            return true;//初始化的值为null，不做处理的话，刚打开MessageBox就会校验出错，影响用户体验
                        }
                        return false;
                    },
                }).then(({value}) => {
                    if(value.trim() != '' && value != null){
                        if(this.Parent.Name == value){
                            this.update(data,value)
                        }else {
                            var params = {tenantId:this.getcookie('storeId'),categoryName:value};
                            this.$http.post(this.productURL+"/vueFeign/uniquenessName",params
                            ).then(res => {
                                if (res.status === 200) {
                                    if (res.data.Code === '200') {
                                        this.update(data,value)
                                    } else if(res.data.Code === '201'){
                                        this.flag = false;
                                        this.$message.error('名称已存在')
                                    }
                                }
                            },function(response){
                                this.items = []
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'
                                });
                            })
                        }
                    }
                }).catch(() => {
                    this.$message({type: 'info', message: '取消输入'})
                })

            },
            update(data,value){
                this.inputflag = true;
                this.Parent.Name = value
                this.Parent.ID = data.categoryId
                this.Parent.ParentID = data.parentId
                this.Parent.Notes = 'Here is Notes Updated'
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/category/update",
                    data: {
                        Category:this.Parent,
                        tenantId:that.getcookie('storeId'),
                    }
                }).then(function(res) {
                    if (res.status === 200) {
                        if (res.data.Code === '200') {
                            that.fusionCateUpdate('update',data.categoryId);
                            that.getCate()
                        } else {
                            this.$message.error('数据获取失败，异常：' + res.data.Meta)
                            that.getCate()
                        }
                    }
                });
            },
            newCate () {
                var Parent = {
                    'ParentID': '',
                    'Index': 0,
                    'Name': 'Category-1',
                    'Notes': 'Here is Notes',
                    'Thumbnail': {
                        'ID': '',
                        'Type': '',
                        'Md5': '',
                        'Size': 0,
                        'Width': 0,
                        'Height': 0,
                        'Url': ''
                    },
                    'Config': {}
                }
                this.$prompt('请输入类名', '新增品类', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({value}) => {
                    var params = {tenantId:this.getcookie('storeId'),categoryName:value};
                    this.$http.post(this.productURL+"/vueFeign/uniquenessName",params
                    ).then(res => {
                        if (res.status === 200) {
                            if (res.data.Code === '200') {
                                Parent.Name = value
                                var that = this;
                                axios({
                                    method: 'post',
                                    url: this.productURL+"/vueFeign/category/add",
                                    data: {
                                        Category:Parent,
                                        tenantId:that.getcookie('storeId'),
                                    }
                                }).then(function(res) {
                                    if (res.status === 200) {
                                        if (res.data.Code === '200') {
                                            that.fusionCateAdd(res.data.cgId);
                                            that.getCate()
                                        } else {
                                            that.$message.error('数据获取失败，异常：' + res.data.Meta)
                                        }
                                    }
                                });
                            } else if(res.data.Code === '201'){
                                this.$message.error('名称已存在')
                            }
                        }
                    },function(response){
                        this.items = []
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                }).catch(() => {
                    this.$message({type: 'info', message: '取消'})
                })
            },
            uniquenessName(){

            },
            toPro (data) {
                this.$router.push({path: 'pro', query: {cateID: data.categoryId}})
            },
            addDomain () {
                this.dynamicValidateForm.domains.push({
                    value: '',
                    key: Date.now()
                })
            },
            getCateConfig: function (data) {
                this.selectCate = data
//                categoryConfig(data.Node.ID).then(res => {
//                    if (res.data.Code === '200') {
//                        this.cateEditModel = true
//                        for (let configs in res.data.Data.Config) {
//                            console.log(configs)
//                        }
//                    } else {
//                        this.$message.error('数据获取失败，异常：' + res.data.Meta)
//                    }
//                }).catch(err => {
//                    this.$message.error('数据获取失败，异常：' + err)
//                })
            },
            updateCateConfig: function (data) {
                for (let i = 0; i < this.dynamicValidateForm.domains.length; i++) {
                    let conf = this.dynamicValidateForm.domains[i]
                    this.config[conf.key] = conf.value
                }
//                categoryConfigUpdate(data.ID, this.config).then(res => {
//                    if (res.data.Code === '200') {
//                        this.cateEditModel = false
//                        this.dynamicValidateForm.domains = []
//                    } else {
//                        this.$message.error('数据获取失败，异常：' + res.data.Meta)
//                    }
//                }).catch(err => {
//                    this.$message.error('数据获取失败，异常：' + err)
//                })
            },
            updateCate: function (data) {
                let Parent = data.Node
                categoryUpdate(Parent).then(res => {
                    if (res.data.Code === '200') {
                        this.getCate()
                    } else {
                        this.$message.error('数据获取失败，异常：' + res.data.Meta)
                    }
                }).catch(err => {
                    this.$message.error('数据获取失败，异常：' + err)
                })
            },
            fusionCateAdd(cgId){
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/fusion/cateAdd?tenantId="+that.getcookie('storeId')+"&cgId="+cgId,
                }).then(function(response) {
                    if (response.status === 200) {
                        if (response.data.Code == '200') {

                        } else {
                            that.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
            fusionCateUpdate(status,cgId){
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/fusion/cateUpdate?tenantId="+that.getcookie('storeId')+"&status="+status+"&cgId="+cgId,
                }).then(function(response) {
                    if (response.status === 200) {
                        if (response.data.Code == '200') {
                            that.getCate();
                        } else {
                            that.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .childList {
        width: 20%;
        padding:5px 0px 5px;
        position: relative;
        display: block;
        text-align: center;
        border-bottom: 1px solid #e0e0e0;
        background:#f9f9f9
    }
</style>



// WEBPACK FOOTER //
// Cate.vue?a6c5665c